import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import { FuturoImperfectoExamplesData, futuroImperfectoExplanation, futuroImperfectoIrregular, futuroImperfectoRegular } from "src/data/individual-topics/FutureSimple";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import ConjugationTable from "src/components/tables/ConjugationTable";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle";

const FuturoImperfectoContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>

            {/* Explanation Card */}
            <div className="section">
                <ExplanationCard cardData={futuroImperfectoExplanation} />
            </div>

            {/* Example Title */}
            <ExampleTitle />

            {/* Futuro Imperfecto Examples */}
            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {FuturoImperfectoExamplesData.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            {/* Conjugation Tables */}
            <div className="section">
                <ConjugationTable tableData={futuroImperfectoRegular} />
            </div>

            <div className="section">
                <ConjugationTable tableData={futuroImperfectoIrregular} />
            </div>

        </div>
    );
};

const FuturoImperfectoScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Simple Future"
            Page={<FuturoImperfectoContent />}
        />
    );
};

export default FuturoImperfectoScreen;
